module.exports = __webpack_public_path__ + "static/media/icon_alerta.522a5a6f.svg";